<!--
File: cc-grid.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 9th May 2025 7:11:32 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div
  *ngIf="!loading"
  class="page-view"
  [style.background-image]="'url(' + currentPageTemplate.imageData + ')'"
>
  <div
    class="flex flex-row justify-content-evenly min-w-max border-0 m-0"
    [ngClass]="isOdd ? 'justify-content-start' : 'justify-content-end'"
  >
    <div class="p-1 m-0 relieve-selector pl-2 pr-2">
      <app-cc-grid-selector
        (locked)="lock($event)"
        (newGridFormat)="changePageFormat($event)"
        (saveFormat)="saveGridFormat($event)"
        [lock]="initialLockButtos"
        [grids]="baseGrids"
        [currentGrid]="currentPageTemplate"
        [pageId]="page.id"
      ></app-cc-grid-selector>
    </div>
  </div>

  <div class="wrap-grid border-0 pt-1 pb-1">
    <div
      *ngIf="page"
      class="cc-grid"
      id="page-{{ page.id }}"
      [ngStyle]="grid.getGridStyle()"
    >
    
      <ng-container *ngFor="let cell of grid.cells">
        <app-cc-cell
          *ngIf="cell.data.visible"
          [cellId]="grid.cells.indexOf(cell)"
          [item]="cell.data.product"
          [grid]="grid"
          [ngStyle]="cell.getStyle()"
          [idCatalog]="idCatalog"
          [idFascicle]="idFascicle"
          [idPage]="idPage"
          [locked]="lockedButtons"
          (refresh)="refreshCell()"
        ></app-cc-cell>
      </ng-container>
    </div>

    <div class="logging" *ngIf="logging">
      <div>
        {{ idPage }}
      </div>
    </div>
  </div>
  <div
    class="flex flex-row align-items-center justify-content-around align-content border-round-xl border-0"
  >
    <span class="relieve-pagina highlight-page-number">{{
      page.pageNumber
    }}</span>
  </div>
</div>
